import NotFound from 'app/components/NotFound/NotFound';
import { BasePageProps } from 'types/common';

const withNextgenRoute = <T extends BasePageProps>(PageComponent: (props: T) => JSX.Element) => {
  const NextgenRoute = (props: T) => {
    if (props?.notFoundData) {
      return <NotFound data={props.notFoundData} showError={false} />;
    }
    return <PageComponent {...props} />;
  };

  return NextgenRoute;
};

export default withNextgenRoute;
